/** Shape shared by every application form field descriptor. */
export interface FieldConfig {
    label: string;
    name: string;
    sqlColumn: string;
    isRequired: boolean;
    subtext?: string;
}

const FumigationCompanyConstants = {
    SECTION_TITLE: 'Fumigation Company / Contractor Information',
    SECTION_SUBTITLE: 'For questions regarding a gas odor or carbon monoxide please call us immediately at 1-800-427-2200',
    SECTION_SUBTITLE_2: 'Do not use this form to report an emergency.',

    COMPANY_LIST: {
        label: 'Fumigation Company List',
        name: 'Fumigation Company List',
        sqlColumn: 'fumigationCompanyList',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    COMPANY_NAME: {
        label: 'Fumigation Company Name',
        name: 'Fumigation Company Name',
        sqlColumn: 'fumigationCompanyName',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    CONTACT_PERSON: {
        label: 'Contact Person',
        name: 'Contact Person',
        sqlColumn: 'contactPerson',
        isRequired: true,
        subtext: '',
    } as FieldConfig,


    TELEPHONE_NUMBER: {
        label: 'Telephone Number',
        name: 'Telephone Number',
        sqlColumn: 'telephoneNumber',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    EXTENSION: {
        label: 'Extension',
        name: 'Extension',
        sqlColumn: 'telephoneNumberExtension',
        isRequired: false,
        subtext: '',
    } as FieldConfig,


    EMAIL_ADDRESS: {
        label: 'Email Address',
        name: 'Email Address',
        sqlColumn: 'emailAddress',
        isRequired: true,
        subtext: '',
    } as FieldConfig,



    ALT_CONTACT_PERSON: {
        label: 'Alternate Contact',
        name: 'Alternate Contact',
        sqlColumn: 'alternateContact',
        isRequired: false,
        subtext: '',
    } as FieldConfig,

    ALT_TELEPHONE_NUMBER: {
        label: 'Alternate Telephone Number',
        name: 'Alternate Telephone Number',
        sqlColumn: 'alternateTelephoneNumber',
        isRequired: false,
        subtext: '',
    } as FieldConfig,

    ALT_EXTENSION: {
        label: 'Alternate Extension',
        name: 'Alternate Extension',
        sqlColumn: 'alternateTelephoneNumberExtension',
        isRequired: false,
        subtext: '',
    } as FieldConfig,


    ALT_EMAIL_ADDRESS: {
        label: 'Alternate Email Address',
        name: 'Alternate Email Address',
        sqlColumn: 'alternateEmailAddress',
        isRequired: false,
        subtext: '',
    } as FieldConfig,

};

export default FumigationCompanyConstants;
